"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m14.78 12 8.64-8.64a2 2 0 0 0 -2.78-2.78l-8.64 8.64-8.64-8.64a2 2 0 0 0 -2.78 2.78l8.64 8.64-8.64 8.64a2 2 0 0 0 0 2.78 1.92 1.92 0 0 0 1.42.58 2 2 0 0 0 1.39-.58l8.61-8.64 8.64 8.64a2 2 0 0 0 1.36.58 1.92 1.92 0 0 0 1.39-.58 2 2 0 0 0 0-2.78z"
  }));
};

exports["default"] = _default;